import Vue from 'vue';
import Router from 'vue-router';

import authenticated from './middleware/authenticated';
import anonymous from './middleware/anonymous';

import Home from './views/Home.vue';
import Library from './views/Library.vue';
import Product from './views/product/Product.vue';
import ProductContents from './views/product/ProductContents.vue';
import ProductUnit from './views/product/ProductUnit.vue';
import ProductExercises from './views/product/ProductExercises.vue';
import ProductAssignments from './views/product/ProductAssignments.vue';
import ProductSimulator from './views/product/ProductSimulator.vue';

import Resource from './views/Resource.vue';
import Assignment from './views/Assignment.vue';
import Launch from './views/Launch.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    scrollBehavior(){
        return {x: 0, y: 0};
    },
    routes: [
        {
            path: '',
            name: 'home',
            component: Home
        },
        {
            path: '/library',
            name: 'library',
            component: Library,
            meta: {
                middleware: [authenticated]
            }
        },
        {
            path: '/assignments/:assignment',
            name: 'assignment',
            component: Assignment
        },
        {
            path: '/assignments/:assignment/launch',
            name: 'launch',
            component: Launch
        },
        {
            path: '/library/:product',
            component: Product,
            name: 'product',
            redirect: '/library/:product/units',
            meta: {
                middleware: [authenticated]
            },
            children: [
                {
                    path: 'contents',
                    name: 'product.contents',
                    component: ProductContents
                },
                {
                    path: 'units',
                    name: 'product.units'
                },
                {
                    path: 'units/:unit',
                    name: 'product.units.unit',
                    component: ProductUnit
                }
            ]
        },
        {
            path: '/library/:product/units/:unit/resources/:resource',
            component: Resource,
            name: 'resource',
            meta: {
                middleware: [authenticated]
            }
        }
    ]
});

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if(!subsequentMiddleware){
        return context.next;
    }

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Than run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    const middleware = [];

    for(const match of to.matched){
        if(match.meta.middleware){
            middleware.push(...(Array.isArray(match.meta.middleware) ? match.meta.middleware : [match.meta.middleware]));
        }
    }

    if(middleware.length){
        const context = {from, next, router, to};
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({...context, next: nextMiddleware});
    }

    return next();
});

export default router;
